import { accountApi } from "../../config/apiConfig";
import { OnboardingReminders, ProspectDetail } from "../../types/onboarding";

// Onboarding reminders (CWA-189) on acc-management, per
// specs/029-onboarding-reminders/contracts/api.md there. Every reminder action
// answers with the prospect's whole reminder ladder. Bodyless POSTs send `{}`:
// this service answers a POST without a body with 415.

// POST /admin/prospects/{id}/reminders/snooze — `until` is a calendar date
// (tomorrow … 90 days ahead), null removes the snooze.
export const snoozeReminders = async (
  id: string,
  until: string | null
): Promise<OnboardingReminders> => {
  const response = await accountApi.post(`admin/prospects/${id}/reminders/snooze`, { until });
  return response.data;
};

// POST /admin/prospects/{id}/reminders/send-next — sends the next rung now,
// recorded as MANUAL.
export const sendNextReminder = async (id: string): Promise<OnboardingReminders> => {
  const response = await accountApi.post(`admin/prospects/${id}/reminders/send-next`, {});
  return response.data;
};

// POST /admin/prospects/{id}/reminders/call — note 1–2,000 chars; clears
// Needs follow-up and snoozes when a date is given.
export const logFollowUpCall = async (
  id: string,
  note: string,
  snoozeUntil?: string | null
): Promise<OnboardingReminders> => {
  const response = await accountApi.post(`admin/prospects/${id}/reminders/call`, {
    note,
    ...(snoozeUntil ? { snooze_until: snoozeUntil } : {}),
  });
  return response.data;
};

// POST /admin/prospects/{id}/more-info/resolve — the customer sent what support
// asked for. Answers with the admin prospect detail.
export const resolveMoreInfo = async (id: string): Promise<ProspectDetail> => {
  const response = await accountApi.post(`admin/prospects/${id}/more-info/resolve`, {});
  return response.data;
};
